// app/javascript/auth_toggles.js

export function initPasswordVisibilityToggles() {
  document.addEventListener("click", function (event) {
    const toggleBtn = event.target.closest(".show-pass");
    if (!toggleBtn) return;

    const wrapper = toggleBtn.closest(".position-relative");
    if (!wrapper) return;

    const passwordInput = wrapper.querySelector(".ic-password");
    if (!passwordInput) return;

    if (passwordInput.type === "password") {
      passwordInput.type = "text";
      toggleBtn.classList.add("active"); // Allows CSS transformations or adjustments if supported
      
      // Toggle standard visual helper states natively
      const showIcon = toggleBtn.querySelector(".show i");
      if (showIcon) showIcon.className = "fa fa-eye";
    } else {
      passwordInput.type = "password";
      toggleBtn.classList.remove("active");
      
      const showIcon = toggleBtn.querySelector(".show i");
      if (showIcon) showIcon.className = "fa fa-eye-slash";
    }
  });
}

// Global hook listener matching DOM setups
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initPasswordVisibilityToggles);
} else {
  initPasswordVisibilityToggles();
}
